// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"f4c256d3","453":"69b360b5","727":"6a354295","728":"2799b6d5","766":"2579ea13","886":"42d724cb"}[chunkId] + ".chunk.js";
};